





























































import Vue from "vue"
import http from './plugins/http';
import { Menu } from "./modules/Menu";
import * as Common from "./commons/common";


export type Datatype = {
  isSignIn: boolean
  user: {login_id: string, name: string, role: string, school_id: string, school_options: object[]}
}

export default Vue.extend({
  computed: {
    userName(): string {
      if(this.$store.state.currentUser){
        const sufix = this.$store.state.currentUser.role == Common.RoleEnum.Student ? "さん" : "先生";
        return `${this.$store.state.currentUser.name}${sufix}`;
      }else{
        return "";
      }
    },
    isSignIn(): boolean {
      const path: string = this.$route.fullPath;
      return path === "/" || path.indexOf("student_site/sign_in") != -1;
    }
  },
  async created(): Promise<void> {
    this.$store.dispatch("hideOverlay");
    const inputs = document.getElementsByTagName("input");
    for(var i = 0; i < inputs.length; i++){
      inputs[0].setAttribute("autocomplete", "off");
    }
    await this.searchCurrentInfo();

    this.$bvModal.hide("msg-box");
    this.$store.commit("setIsShowingMsgBox", false);
  },
  methods: {
    to(menu: Menu): void {
      this.$router.push(menu.toUrl).catch((err: any) => {});
    },
    async searchCurrentInfo(): Promise<void> {
      const path: string = this.$route.fullPath;
      
      if(path.indexOf("student_site/sheet_list") != -1){
        
      }else if(this.isSignIn){
        await http.get("/api/master_data/version").then((response) =>{
          const version = response.data.version;
          const cookieVersion = Common.getCookieValue(document.cookie, "smarky_version");
          console.log(`api:${version}, cookie:${cookieVersion}`);
          if(version != cookieVersion){
            document.cookie = 'smarky_version=' + version;
            window.location.reload(true);
            return;
          }
        });
        await http.get("/api/master_data/mainte_infos").then((response) =>{
          const mainteInfos = response.data;
          this.$store.commit("setMainteInfo", mainteInfos);
        });
      }else{
        await http.get("/api/current_user").then((response) =>{
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setSchools", response.data.schools);
          this.$store.commit("setRooms", response.data.rooms);
          this.$store.commit("setEvents", response.data.events);
          this.$store.commit("setCurriculums", response.data.curriculums);
          this.$store.commit("setMainteInfo", response.data.mainte_infos);
        });
      }
    },
    logoClick(){
      if(this.$store.state.currentUser.role == Common.RoleEnum.Student){
        this.$router.push(`/student_site/sheet_list`).catch((err: any) => {});
      }else{
        this.$router.push('/teacher_site/sheet_list').catch((err: any) => {});
      }
    },
    signOut(){
      const url = window.location.href;

      // @ts-ignore
      const params = {access_token: document.cookie.match(/access_token=(.*)/)[1]}
      http.post(`/api/logout/${this.$store.state.currentUser.id}`, params).then((response) => {
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        // URLから生徒ログイン・教師ログインの戻り先判定
        if(url.indexOf("student_site") != -1){
          // $storeで保持しているログインユーザ情報・生徒CDをクリア
          this.$store.commit("setCurrentUser", null);
          this.$store.commit("setCramStudentId", null);
          
          window.close();

          // マイページへ遷移
          window.location.href = `https://w2.hamagakuen.jp/login`;
        }else{
          // $storeで保持しているログインユーザ情報をクリア
          this.$store.commit("setCurrentUser", null);

          // 教師サイトログイン画面へ
          window.location.href="/#/"
        }
      })
    },
    // チャットの表示状態切り替え
    chatDipsChange(){

    }
  },
  watch: {
    async "$route" (toUrl: any, fromUrl: any){
      this.$bvModal.hide("msg-box");
      this.$store.commit("setIsShowingMsgBox", false);
      this.chatDipsChange();
      this.$store.dispatch("hideOverlay");
      const inputs = document.getElementsByTagName("input");
      for(var i = 0; i < inputs.length; i++){
        inputs[0].setAttribute("autocomplete", "off");
      }
      if(toUrl !== fromUrl){
        await this.searchCurrentInfo();
      }
    }
  },
  mounted(){
    this.chatDipsChange();
  }
});
